import { render, staticRenderFns } from "./KModal.vue?vue&type=template&id=31f6c6db&"
import script from "./KModal.vue?vue&type=script&lang=js&"
export * from "./KModal.vue?vue&type=script&lang=js&"
import style0 from "./KModal.vue?vue&type=style&index=0&id=31f6c6db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports